import {
  previewContentTransferAdminAPI,
  contentTransferAdminAPI,
  getContentTransferHistoryAdminAPI,
  lookupReleaseForTransferAdminAPI,
  lookupUserForTransferAdminAPI,
} from "./api";

export function previewContentTransferAdmin(data) {
  return new Promise((resolve, reject) => {
    previewContentTransferAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function contentTransferAdmin(data) {
  return new Promise((resolve, reject) => {
    contentTransferAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function getContentTransferHistoryAdmin(filters) {
  return new Promise((resolve, reject) => {
    getContentTransferHistoryAdminAPI(filters)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function lookupReleaseForTransferAdmin(release_id) {
  return new Promise((resolve, reject) => {
    lookupReleaseForTransferAdminAPI(release_id)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function lookupUserForTransferAdmin(user_id) {
  return new Promise((resolve, reject) => {
    lookupUserForTransferAdminAPI(user_id)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}
